// extracted by mini-css-extract-plugin
module.exports = {"container":"EnlevInfo_container__SSdv1","logoContainer":"EnlevInfo_logoContainer__4kGG3","textContainer":"EnlevInfo_textContainer__zeMPR"};